import {FC, useEffect, useRef, useState} from "react";
import {IGroup} from "../../types/ApiTypes";
import useApi from "../../hooks/useApi";
import Card from "../ui/Card";
import { BsCheckCircle, BsExclamationCircle, BsTrash } from "react-icons/bs";
import {CgSpinner} from "react-icons/cg";
import AlertMessage from "../ui/AlertMessage";
import Button from "../ui/Button";

interface Props {
  space: IGroup;
  onRemove: () => void;
}

const SpaceDetailsHeartbeat: FC<Props> = ({space,onRemove}) => {
  const mounted = useRef(false);
  const {getSpaceHeartbeat} = useApi();
  const [loading, setLoading] = useState(false);
  const [groupExists, setGroupExists] = useState(false);
  const [apExists, setApExists] = useState(false);
  const [mpExists, setMpExists] = useState(false);
  const [opExists, setOpExists] = useState(false);
  const [gpExists, setGpExists] = useState(false);

  useEffect(() => {
    mounted.current = true;
    return () => {mounted.current = false}
  },[]);

  useEffect(() => {
    setLoading(true);
    getSpaceHeartbeat(space.requestId).then((res) => {
      if(res && mounted.current) {
        setGroupExists(res.aadGroup);
        setApExists(res.aadAccessPackage);
        setMpExists(res.aadMemberPolicy);
        setOpExists(res.aadOwnerPolicy);
        setGpExists(res.aadGuestPolicy);
        setLoading(false);
      }
    })
  },[getSpaceHeartbeat, space.requestId, space.request_state])

  const getIcon = (check: boolean) => {
    return check ? <BsCheckCircle className={`text-xl mr-2 text-success-darker`}/> : <BsExclamationCircle className={`text-xl mr-2 text-error-brighter`}/>
  }

  return (
    <Card title='Space Heartbeat'>
      {!loading && (
        <>
          <ul className='space-y-4 mb-3'>
            <li className='grid grid-cols-12 items-center'>
              {getIcon(groupExists)}
              <div className='flex flex-col col-span-11'>
                <span>AAD Group</span>
              </div>
            </li>
            <li className='grid grid-cols-12 items-center'>
              {getIcon(apExists)}
              <div className='flex flex-col col-span-11'>
                <span>IG Access Package</span>
              </div>
            </li>
            <li className='grid grid-cols-12 items-center'>
              {getIcon(opExists)}
              <div className='flex flex-col col-span-11'>
                <span>IG Owner Policy</span>
              </div>
            </li>
            <li className='grid grid-cols-12 items-center'>
              {getIcon(mpExists)}
              <div className='flex flex-col col-span-11'>
                <span>IG Member Policy</span>
              </div>
            </li>
            <li className='grid grid-cols-12 items-center'>
              {getIcon(gpExists)}
              <div className='flex flex-col col-span-11'>
                <span>IG Guest Policy</span>
              </div>
            </li>
          </ul>
          <div className='flex flex-col gap-2'>
            <AlertMessage severity='info'>
              Space Heartbeat zeigt, ob alle Komponente eines Spaces in Azure Active Directory sowie Identity Governance erstellt wurden.<br/>
              Guest Policy ist keine Pflicht-Komponente
            </AlertMessage>
            {(!groupExists && apExists) && <AlertMessage severity='error'>
              Ein AccessPackage ist vorhanden obwohl die Gruppe in Azure AD nicht existiert. Das AccessPackage soll gelöscht werden.
            </AlertMessage>}
            {(!groupExists && !apExists) && (
              <>
                <AlertMessage severity='warning'>
                  Die Gruppe existiert nicht mehr oder konnte nicht erstellt werden. Der Datensatz soll gelöscht oder erneut erstellt werden
                </AlertMessage>
                <Button className='bg-error-brighter hover:shadow-error-brighter/20' onClick={onRemove}>
                  <BsTrash className='mr-2 text-xl'/> Datensatz löschen
                </Button>
              </>
            )}
          </div>
        </>
      )}
      {loading && <CgSpinner className='animate-spin mx-auto text-5xl block'/>}
    </Card>
  );
};

export default SpaceDetailsHeartbeat;